(() => {
  if (window.LmcdKidneyFriendly) return;
  const mount = root => {
    if (!root || root.dataset.kidneyReady === 'true') return;
    root.dataset.kidneyReady = 'true';
    const cleanup = [];
    const listen = (target, event, handler, options) => {
      target.addEventListener(event, handler, options);
      cleanup.push(() => target.removeEventListener(event, handler, options));
    };
    const faqs = [...root.querySelectorAll('[data-kidney-faq]')];
    faqs.forEach(faq => listen(faq.querySelector('summary'), 'click', () => {
      if (!faq.open) faqs.forEach(other => { if (other !== faq) other.open = false; });
    }));
    root.querySelectorAll('[data-kf-carousel]').forEach(carousel => {
      const track = carousel.querySelector('[data-kf-track]');
      const move = direction => {
        const step = track.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
        const current = track.scrollLeft;
        const maximum = track.scrollWidth - track.clientWidth;
        let target = current + direction * step;
        // Recycle the four actual source cards at an edge; never duplicate media.
        if (direction < 0 && current < step - 1) {
          track.style.scrollSnapType = 'none';
          track.prepend(track.lastElementChild);
          track.scrollTo({left: current + step, behavior: 'instant'});
          target = current;
        } else if (direction > 0 && target > maximum + 1) {
          track.style.scrollSnapType = 'none';
          track.append(track.firstElementChild);
          track.scrollTo({left: Math.max(0, current - step), behavior: 'instant'});
          target = current;
        }
        track.style.removeProperty('scroll-snap-type');
        track.scrollTo({left: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      listen(carousel.querySelector('[data-kf-prev]'), 'click', () => move(-1));
      listen(carousel.querySelector('[data-kf-next]'), 'click', () => move(1));
      let gesture;
      listen(track, 'dragstart', event => event.preventDefault());
      listen(track, 'pointerdown', event => {
        if (!event.isPrimary || event.button !== 0) return;
        if (event.target.closest('video,button,a,input,select,textarea')) return;
        gesture = {id:event.pointerId, x:event.clientX, y:event.clientY};
        track.setPointerCapture(event.pointerId);
      });
      listen(track, 'pointerup', event => {
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        gesture = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) move(dx < 0 ? 1 : -1);
      });
      listen(track, 'pointercancel', () => { gesture = null; });
    });
    const reviewTrack = root.querySelector('.kf-review-track');
    let reviewDrag;
    listen(reviewTrack, 'pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      reviewDrag = {id:event.pointerId, x:event.clientX, scroll:reviewTrack.scrollLeft};
      reviewTrack.setPointerCapture(event.pointerId);
      reviewTrack.style.scrollSnapType = 'none';
    });
    listen(reviewTrack, 'pointermove', event => {
      if (reviewDrag?.id === event.pointerId) reviewTrack.scrollLeft = reviewDrag.scroll + reviewDrag.x - event.clientX;
    });
    const endReviewDrag = event => {
      if (!reviewDrag) return;
      const delta = reviewDrag.x - event.clientX;
      const step = reviewTrack.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(reviewTrack).gap) || 0);
      const target = reviewDrag.scroll + (Math.abs(delta) > 40 ? Math.sign(delta) * step : 0);
      reviewDrag = null;
      reviewTrack.style.removeProperty('scroll-snap-type');
      reviewTrack.scrollTo({left: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    listen(reviewTrack, 'pointerup', endReviewDrag);
    listen(reviewTrack, 'pointercancel', () => { reviewDrag = null; reviewTrack.style.removeProperty('scroll-snap-type'); });
    const form = root.querySelector('[data-lmcd-house-primary-form]');
    const finalSubmit = root.querySelector('[data-kidney-final-submit]');
    if (form && finalSubmit && !finalSubmit.disabled) listen(finalSubmit, 'click', () => form.requestSubmit());
    const proof = root.querySelector('.kf-proof-track');
    let animation;
    if (proof && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const keyframes = () => {
        const distance = (proof.scrollWidth + (parseFloat(getComputedStyle(proof).gap) || 0)) / 3;
        return [{transform:'translateX(0)'},{transform:`translateX(-${distance}px)`}];
      };
      animation = proof.animate(keyframes(),{duration:28000,iterations:Infinity});
      // Update the existing effect so elapsed time and hover/pause state survive resizing.
      const resizeObserver = new ResizeObserver(() => animation.effect.setKeyframes(keyframes()));
      resizeObserver.observe(proof);
      cleanup.push(() => resizeObserver.disconnect());
      listen(proof, 'pointerenter', () => animation.pause());
      listen(proof, 'pointerleave', () => animation.play());
    }
    root.__kidneyTeardown = () => {
      cleanup.splice(0).forEach(remove => remove());
      animation?.cancel();
      delete root.dataset.kidneyReady;
    };
  };
  const mountAll = () => document.querySelectorAll('[data-kidney-friendly-offer]').forEach(mount);
  window.LmcdKidneyFriendly = {mount};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, {once:true});
  else mountAll();
  document.addEventListener('shopify:section:load', mountAll);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.('[data-kidney-friendly-offer]')) event.target.__kidneyTeardown?.();
    event.target.querySelectorAll?.('[data-kidney-friendly-offer]').forEach(root => root.__kidneyTeardown?.());
  });
})();
